import React from 'react';
import propTypes from 'prop-types';

export const FoodIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      // viewBox="0 0 24 24"
      // xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -11 61 61"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Group_49"
        data-name="Group 49"
        transform="translate(-788.946 -1785.428)"
      >
        <path
          id="Path_131"
          data-name="Path 131"
          d="M814.946,1793.095a24,24,0,0,0-24,24h48A24,24,0,0,0,814.946,1793.095Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
        />
        <line
          id="Line_51"
          data-name="Line 51"
          x2="48"
          transform="translate(790.946 1825.761)"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
        />
        <line
          id="Line_52"
          data-name="Line 52"
          y2="5.667"
          transform="translate(814.946 1787.428)"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
};
FoodIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
FoodIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
